module.exports = __webpack_public_path__ + "assets/img/b&w-logo.2d7812b6.png";